import Alert from "@amzn/awsui-components-react/polaris/alert";
import { OfferConfigurationResponse } from "Api/useQueryOfferConfiguration";

const OfferConfigurationPageResult = ({ response }: { response: OfferConfigurationResponse }) => {
  if (response.enabled) {
    return <Alert type="success">Your offer is now IBA eligible</Alert>;
  }

  return <Alert type="error">An error occurred: {response.status}</Alert>;
};

export default OfferConfigurationPageResult;
